<div
    class="toast"
    [@fadeAnimation]="{
        value: animationState,
        params: { fadeIn: toastConfig.animation.fadeIn, fadeOut: toastConfig.animation.fadeOut }
    }"
    (@fadeAnimation.done)="onFadeFinished($event)"
>
    <div class="toast-left">
        <fcp-icon *ngIf="data.showIcon" [icon]="data.icon" [border]="data.iconBorder"></fcp-icon>
        <div class="toast-text" data-e2e-hook="toast-data">{{ data.text }}</div>
    </div>

    <div class="toast-right">
        <button class="toast-action" *ngIf="data.action" (click)="handleAction()" fcp-transparent-button color="subtle">
            {{ data.action.text }}
        </button>

        <button
            *ngIf="data.showClose"
            (click)="setAnimationState('closing')"
            fcp-transparent-button
            color="subtle"
            size="medium"
            iconOnly="true"
        >
            <fcp-icon [icon]="['fal', 'times']"></fcp-icon>
        </button>
    </div>
</div>
